import { Component, OnInit } from '@angular/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-footer-login',
  templateUrl: './footer-login.component.html',
  styleUrls: ['./footer-login.component.css']
})
export class FooterLoginComponent implements OnInit {

  anio: number;

  constructor() { }

  ngOnInit(): void {
    this.anio = new Date().getFullYear();
  }

}
